import { useMemo } from 'react';

import isEmpty from 'lodash/isEmpty';

import { useDashboard } from '@/hooks/api/dashboard';

export const useDashboardMenuItems = () => {
  const { data } = useDashboard();

  return useMemo(() => {
    if (data && !isEmpty(data)) {
      return Object.keys(data).map(name => ({
        key: name,
        id: name,
        name,
        path: `/dashboard/${encodeURIComponent(name)}`
      }));
    }
    return [
      {
        key: 'New Dashboard',
        id: 'New Dashboard',
        name: 'New Dashboard',
        path: '/dashboard/new'
      }
    ];
  }, [data]);
};
